import React from 'react';
import styled from 'styled-components';
import { isWindows, isMacOs } from 'react-device-detect'
import { v4 as uuidv4 } from 'uuid';

import { Paper } from 'components'
import { BiCommand } from 'react-icons/bi'

const defaultStyle = {
    primaryColor: 'var(--primary-color)',
    secondaryColor: 'var(--secondary-color)'
}

const Container = styled.div`
    width: 20rem;
    padding: 1rem;
    border-radius: 5px;
    background-color: ${props => props.styles.primaryColor};
    display: flex;
    flex-direction: column;
    font-size: 0.8rem;
`

const Row = styled.div`
    display: grid;
    grid-template-columns: 50% 50%;
    justify-items: start;
    align-items: center;
    background-color: ${props => props.styles.secondaryColor};
    grid-column-gap: 2px;
`

const Title = styled.div`
    font-weight: bolder;
    font-size: 1.2rem;
`

const Command = styled.div`
    background-color: ${props => props.styles.primaryColor};
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
`

const ButtonContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    background-color: ${props => props.styles.primaryColor};
    padding-left: 0.5rem;
`

const Button = styled.div`
    border-radius: 5px;
    background-color: ${props => props.styles.secondaryColor};
    min-width: 1.5rem;
    min-height: 1.5rem;
    padding: 0.3rem;
    margin: 0.2rem 0.4rem 0.2rem 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    :hover{
        filter: brightness(var(--brightness));
    }
`

const editorShortcuts = {
    'Bold': ['command', 'b'],
    'Italics': ['command', 'i'],
    'Underline': ['command', 'u'],
    'Code': ['command', 'e'],
    'Highlight': ['command', 'h'],
    'Embed link': ['command', 'k'],
    'Indent code': ['tab'],
    'Remove code indent': ['shift','tab'],
    'New line': ['shift', 'enter']
}

const commonShortcuts = {
    'Search': ['command', 'p'],
    'Create new item': ['command', 'n'],
    'Undo': ['command', 'z'],
    'Redo': ['command', 'shift', 'z'],
    'Close/Exit': ['esc']
}

const ShortcutMenu = props => {
    const {
        primaryColor,
        secondaryColor,
    } = props;
    const updatedStyle = Object.assign({}, {primaryColor: primaryColor || defaultStyle['primaryColor'], secondaryColor: secondaryColor || defaultStyle['secondaryColor']})
    let content = []
    for (const [key, commands] of Object.entries(editorShortcuts)) {
        content.push(
            <Row key={uuidv4()} styles={updatedStyle}>
                <Command key={uuidv4()} styles={updatedStyle}>{key}</Command>
                <ButtonContainer key={uuidv4()} styles={updatedStyle}>
                    {commands.map(command => {
                        if(command === 'command' & isMacOs){
                            return <Button key={uuidv4()} styles={updatedStyle}><BiCommand size='12'/></Button>
                        } else if (command === 'command') {
                            return <Button key={uuidv4()} styles={updatedStyle}>Ctrl</Button>
                        } else if (['shift','tab','enter']) {
                            return <Button key={uuidv4()} styles={updatedStyle}>{command.charAt(0).toUpperCase() + command.slice(1)}</Button>
                        } else {
                            return <Button key={uuidv4()} styles={updatedStyle}>{command.toUpperCase()}</Button>
                        }
                    })}
                </ButtonContainer>
                
            </Row>
        )
    }
    return(
        <Paper style={{margin: '0.5rem 0'}}>
            <Container styles={updatedStyle}>
                {content}
            </Container>
        </Paper>
    )
}

export default ShortcutMenu